import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { QRCodeSVG } from 'qrcode.react';
import { Smartphone, Copy, Check, Loader2 } from 'lucide-react';
import { Modal, Btn, INPUT, cx, when } from '../contacts/ui';

const API = process.env.REACT_APP_BACKEND_URL;

// Desktop → phone hand-off: QR code that opens this exact session after a normal sign-in.
export const PhoneHandoff = ({ sid, headers, className }) => {
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState(null);
  const [err, setErr] = useState('');
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!open) return;
    setLink(null); setErr('');
    axios.post(`${API}/api/calling/sessions/${sid}/handoff`, {}, { headers })
      .then((r) => setLink({ url: `${window.location.origin}/calling/phone/${r.data.token}`, expires: r.data.expires_at }))
      .catch((e) => setErr(e.response?.data?.detail || 'Could not create a phone link'));
  }, [open, sid, headers]);
  const copy = async () => { try { await navigator.clipboard.writeText(link.url); setCopied(true); setTimeout(() => setCopied(false), 1500); } catch { setCopied(false); } };
  return (
    <>
      <Btn tone="ghost" className={cx('w-full', className)} onClick={() => setOpen(true)} data-testid="call-phone-handoff-btn"><Smartphone className="h-4 w-4" />Continue on my phone</Btn>
      <Modal open={open} onClose={() => setOpen(false)} title="Dial from your phone" testid="call-phone-handoff-dialog">
        {err && <p className="text-sm font-semibold text-[var(--red)]" data-testid="call-phone-handoff-error">{err}</p>}
        {!link && !err && <p className="flex items-center gap-2 text-sm text-[var(--muted)]"><Loader2 className="h-4 w-4 animate-spin" />Creating your link…</p>}
        {link && (<div className="text-center">
          <div className="mx-auto w-fit rounded-2xl bg-white p-4" data-testid="call-phone-handoff-qr"><QRCodeSVG value={link.url} size={196} level="M" /></div>
          <p className="mx-auto mt-4 max-w-xs text-sm text-[var(--ink-2)]">Scan with your phone camera, sign in as usual, and this queue opens ready to dial. Calls you log on either device stay in sync.</p>
          <div className="mt-4 flex gap-2"><input readOnly value={link.url} className={cx(INPUT, 'text-xs')} data-testid="call-phone-handoff-url" onFocus={(e) => e.target.select()} />
            <Btn tone="solid" onClick={copy} data-testid="call-phone-handoff-copy">{copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}{copied ? 'Copied' : 'Copy'}</Btn></div>
          <p className="mt-2 text-xs text-[var(--faint)]">Only works for your login · expires {when(link.expires)} or when the session finishes.</p>
        </div>)}
      </Modal>
    </>
  );
};
